import React from 'react'
import { Link } from 'react-router-dom'
import {
  BorderStyle,
  Box,
  Color,
  Heading3,
  IconProps,
} from '@gousto-internal/citrus-react'
import { TopicBackground } from './TopicBackground'
import cssTopicBackground from './TopicBackground/TopicBackground.module.css'
import css from './Topic.module.css'

type Nullable<T> = T | null

interface TopicProps {
  categoryId: string;
  categoryNameSlug: string;
  className: string;
  color?: Nullable<string>;
  description: string;
  iconName?: Nullable<IconProps['name']>;
  title: string;
}

export const Topic = ({
  categoryId,
  categoryNameSlug,
  className,
  color = null,
  description,
  iconName = null,
  title,
}: TopicProps) => (
  <div
    className={className}
    data-tracking-action="kb_click_help_category"
    data-tracking-property={JSON.stringify({ category: title })}
  >
    <Box
      className={cssTopicBackground.card}
      borderColor={Color.ColdGrey_100}
      borderStyle={BorderStyle.Solid}
      borderWidth={0.5}
      borderRadius={1}
    >
      <Link to={`/categories/${categoryNameSlug}/${categoryId}`}>
        <TopicBackground categoryId={categoryId} color={color} iconName={iconName} />
        <div className={css.text}>
          <Heading3 size={4}>{title}</Heading3>
          {description ? <p className={css.description}>{description}</p> : null}
        </div>
      </Link>
    </Box>
  </div>
)
